const { get, isEmpty } = require("lodash");
const QuestionPrototype = require("./prototypes");

function CheckboxType() {
  this.type = "checkbox";

  this.validate = ({ eligibility, answer }) => {
    const answerObj = typeof answer === "string" ? JSON.parse(answer) : answer;
    const valid = get(eligibility, "valid", []);
    const invalid = get(eligibility, "invalid", []);
    const answers = Object.keys(answerObj || {}).filter((k) => answerObj[k]);
    return (
      (isEmpty(valid) || valid.some((v) => answers.includes(v))) &&
      !answers.some((v) => invalid.includes(v))
    );
  };

  this.serialize = ({ eligibility }) =>
    eligibility.map((obj) => {
      if (!obj || !obj.criteria) {
        return { valid: null };
      }
      const { valid, invalid } = obj.criteria;
      return {
        valid: !isEmpty(valid) ? valid.join() : null,
        invalid: !isEmpty(invalid) ? invalid.join() : null,
      };
    });
}
CheckboxType.prototype = QuestionPrototype;

module.exports = CheckboxType;
